import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import ActionTable from "../../components/table/ActionTable";
import api from "../../services/api";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";

export default function Lista({ history, location }) {
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState(
    mergeParams({ nome: "", exibirInativos: false }, location)
  );
  const [lista, setLista] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);

    api
      .get("eventosPedido/listar", filtrosEnviar)
      .then((res) => {
        res.forEach((item) => {
          item.cor = item.cor ? (
            <div style={{ background: item.cor, width: 50, height: 25 }}></div>
          ) : (
            "(Indefinida)"
          );
        });
        setLista(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar Eventos pedido");
        setCarregando(false);
      });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 8,
        value: dados.nome,
      },
      exibirInativos: {
        label: "Exibir inativos",
        type: "check",
        space: 4,
        value: dados.exibirInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Eventos de pedidos",
    onLineClick: (id) => history.push(`/app/eventos-pedido/${id.id}`),
    newItemAction: () => history.push("/app/eventos-pedido/0"),
    columns: [
      {
        name: "nome",
        label: "Nome",
      },
      {
        name: "ordem",
        label: "Ordem",
      },
      {
        name: "cor",
        label: "Cor",
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={filtros} />

      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
